// extracted by mini-css-extract-plugin
export default {"rating":"GD-z","numberOfStars":"HD-z","count":"ID-z","barGraphSpacing":"JD-z","barGraph":"KD-z"};